import { render, staticRenderFns } from "./account-change-log.vue?vue&type=template&id=50a409a2&scoped=true&"
import script from "./account-change-log.vue?vue&type=script&lang=js&"
export * from "./account-change-log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a409a2",
  null
  
)

export default component.exports